import BreakdownDonutChart from 'features/dashboard/components/BreakdownDonutChart';
import { formatArea } from 'utils/format';
import useLatest from 'utils/hooks/useLatest';
import styles from 'theme/features/dashboard/dashboard-business-unit.module.scss';
import colorStyles from 'theme/features/dashboard/dashboard-site-wide.module.scss';

const BusinessUnitBreakdownChart = ({ breakdown, measurementSystem, isCompact }) => {
  const data = [
    {
      group: 'Collaborative',
      type: 'collaborative',
      value: breakdown.collaborative.workplacePercentage
    },
    {
      group: 'Individual',
      type: 'individual',
      value: breakdown.individual.workplacePercentage
    },
    {
      group: 'Community + Support',
      type: 'communitySupport',
      value: breakdown.communitySupport.workplacePercentage
    },
    {
      group: 'Specialty Spaces',
      type: 'specialty',
      value: breakdown.specialty.workplacePercentage
    },
    {
      group: 'Site Specific',
      type: 'siteSpecific',
      value: breakdown.siteSpecific.workplacePercentage
    }
  ];
  const dataRef = useLatest(data);

  const measurementSystemRef = useLatest(measurementSystem);

  return (
    <div className={styles.chart}>
      <BreakdownDonutChart
        compact={isCompact}
        formatTooltip={(_, group) => {
          const { type } = dataRef.current.find((d) => d.group === group);

          return formatArea(breakdown[type].area, measurementSystemRef.current);
        }}
        colors={{
          Collaborative: colorStyles.collaborative,
          Individual: colorStyles.individual,
          'Community + Support': colorStyles.community,
          'Specialty Spaces': colorStyles.specialty,
          'Site Specific': colorStyles['site-specific']
        }}
        data={data}
      />
    </div>
  );
};

export default BusinessUnitBreakdownChart;
